import { Injectable } from '@angular/core';
import gql from 'graphql-tag';
import IEquivalenciaProducto from '../shared/object/equivalencia-producto.model';
import { GraphQLClient } from '../shared/services/graph-qlclient.service';

@Injectable({
  providedIn: 'root'
})
export class EquivalenciaProductoService {

  constructor(
    private gqlclient: GraphQLClient
  ) { }

  create(inputParams: { entidad: IEquivalenciaProducto }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: equivalencia_productoInputType) {
          equivalencia_producto {
            agregar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                id
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.equivalencia_producto.agregar
        callback({ mensajes, respuesta })
      }
    );
  }

  update(inputParams: { entidad: IEquivalenciaProducto }, callback: Function) {
    this.gqlclient.mutate(
      {
        mutation: gql`
        mutation ($entidad: equivalencia_productoInputType) {
          equivalencia_producto {
            modificar(entidad: $entidad) {
              mensajes {
                codigo
                contexto
                texto
                tipo
              }
              respuesta {
                id
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.equivalencia_producto.modificar
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSegunProveedor(inputParams: {
    entidad: {
      empresa_rut: number
      sucursal_codigo: number
      cliente_proveedor_rut: number
      includeInactive: boolean
    },
    paginaActual: number
    cantidadRegistrosPorPagina: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: equivalencia_productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          equivalencia_producto {
            obtenerSegunProveedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  id
                  empresa_rut
                  sucursal_codigo
                  cliente_proveedor_rut
                  producto_proveedor
                  detalle_producto
                  formato_codigo
                  factor_equivalencia
                  activado
                  observacion
                  producto_codigo
                  producto_sku
                  producto_descripcion
                  formato_codigo_top
                  formato_descripcion_top
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.equivalencia_producto.obtenerSegunProveedor
        callback({ mensajes, respuesta })
      }
    );
  }

  obtenerSegunId(inputParams: {
    id: number
  }, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($id: Int) {
          equivalencia_producto {
            obtenerSegunId(id: $id) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                id
                cliente_proveedor_rut
                producto_codigo
                sucursal_codigo
                formato_codigo
                empresa_rut
                producto_proveedor
                detalle_producto
                activado
                observacion
                fueUsadaEnTransaccion
                producto_sku
                producto_descripcion
                factor_equivalencia
                formato_codigo_top
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.equivalencia_producto.obtenerSegunId
        callback({ mensajes, respuesta })
      }
    );
  }


  obtenerProductoProveedor(inputParams, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        query ($entidad: equivalencia_productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
          equivalencia_producto {
            obtenerProductoProveedor(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
              mensajes {
                codigo
                texto
                tipo
              }
              respuesta {
                paginaActual
                cantidadRegistrosPorPagina
                totalPaginas
                totalRegistros
                registros {
                  id
                  empresa_rut
                  sucursal_codigo
                  cliente_proveedor_rut
                  producto_proveedor
                  detalle_producto
                  formato_codigo
                  factor_equivalencia
                  activado
                  observacion
                  producto_codigo
                  producto_sku
                  producto_descripcion
                  formato_codigo_top
                  formato_descripcion_top
                }
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes, respuesta } = response.data.equivalencia_producto.obtenerProductoProveedor
        callback({ mensajes, respuesta })
      }
    );
  }

  eliminarEquivalencia(inputParams: any, callback: Function) {
    this.gqlclient.query(
      {
        query: gql`
        mutation ($entidad: equivalencia_productoInputType) {
          equivalencia_producto {
            eliminarEquivalencia(entidad: $entidad) {
              mensajes {
                codigo
                texto
                tipo
              }
            }
          }
        }
        `,
        variables: inputParams,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        const { mensajes } = response.data.equivalencia_producto.eliminarEquivalencia
        // Para eliminarEquivalencia, si hay mensajes de error, la operación falló
        // Si no hay mensajes o todos son de tipo INFO, la operación fue exitosa
        const hasErrors = mensajes && mensajes.some(m => m.tipo === 'ERROR')
        const respuesta = hasErrors ? null : { success: true }
        callback({ mensajes, respuesta })
      }
    );
  }

}
